(function () {
  var STORAGE_KEY = 'duschenmann:wishlist';
  var STRAPI_URL = 'https://strapi.duschenmann.de/api/wishlists';
  var customerId = window.wishlistCustomerId ? String(window.wishlistCustomerId) : null;
  var remoteDocumentId = null;
  var remoteReady = false;

  function readItems() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .filter(function (item) {
          return item && item.id;
        })
        .map(function (item) {
          return { id: String(item.id), handle: item.handle || '' };
        });
    } catch (e) {
      return [];
    }
  }

  function writeItems(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage unavailable (private mode, quota, ...) — fail silently */
    }
  }

  var items = readItems();

  function findIndex(id) {
    id = String(id);
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return i;
    }
    return -1;
  }

  function has(id) {
    return findIndex(id) !== -1;
  }

  function toggle(id, handle) {
    var index = findIndex(id);
    var added;
    if (index === -1) {
      items.push({ id: String(id), handle: handle || '' });
      added = true;
    } else {
      items.splice(index, 1);
      added = false;
    }
    writeItems(items);
    document.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { items: items.slice() } })
    );
    pushRemote();
    return added;
  }

  function mergeItems(a, b) {
    var merged = a.slice();
    b.forEach(function (item) {
      if (!item || !item.id) return;
      var exists = merged.some(function (existing) {
        return existing.id === String(item.id);
      });
      if (!exists) merged.push({ id: String(item.id), handle: item.handle || '' });
    });
    return merged;
  }

  function pushRemote() {
    if (!customerId || !remoteReady) return;
    var payload = { data: { customerId: customerId, data: { items: items } } };
    var request = remoteDocumentId
      ? fetch(STRAPI_URL + '/' + remoteDocumentId, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        })
      : fetch(STRAPI_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

    request
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        if (json && json.data && json.data.documentId) {
          remoteDocumentId = json.data.documentId;
        }
      })
      .catch(function () {
        /* offline / API unreachable — local state stays source of truth */
      });
  }

  function syncFromRemote() {
    if (!customerId) return;
    fetch(
      STRAPI_URL + '?filters[customerId][$eq]=' + encodeURIComponent(customerId)
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        remoteReady = true;
        var record = json && json.data && json.data[0];
        var remoteItems =
          (record && record.data && Array.isArray(record.data.items)
            ? record.data.items
            : []
          ).map(function (item) {
            return { id: String(item.id), handle: item.handle || '' };
          });

        if (record) remoteDocumentId = record.documentId;

        var merged = mergeItems(items, remoteItems);
        var changed =
          merged.length !== items.length ||
          merged.some(function (item, i) {
            return !items[i] || items[i].id !== item.id;
          });

        items = merged;
        writeItems(items);
        render();

        if (changed || !record) pushRemote();
      })
      .catch(function () {
        /* API unreachable — keep working from localStorage only */
      });
  }

  function count() {
    return items.length;
  }

  function updateButton(button) {
    var id = button.getAttribute('data-product-id');
    var active = has(id);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      active ? window.wishlistStrings.remove : window.wishlistStrings.add
    );
    var label = button.querySelector('.wishlist-button__label');
    if (label) {
      label.textContent = active
        ? window.wishlistStrings.remove
        : window.wishlistStrings.add;
    }
  }

  function updateCounters() {
    var total = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
      badge.textContent = total > 99 ? '99+' : String(total);
    });
    document
      .querySelectorAll('[data-wishlist-count-wrapper]')
      .forEach(function (wrapper) {
        wrapper.classList.toggle('is-empty', total === 0);
      });
    document.querySelectorAll('.header__icon--wishlist').forEach(function (icon) {
      icon.classList.toggle('has-items', total > 0);
      var outline = icon.querySelector('.header__icon--wishlist-outline');
      var filled = icon.querySelector('.header__icon--wishlist-filled');
      if (outline) outline.style.display = total > 0 ? 'none' : 'inline-flex';
      if (filled) filled.style.display = total > 0 ? 'inline-flex' : 'none';
    });
  }

  var panelCache = {};

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (panelCache[handle]) return Promise.resolve(panelCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (product) panelCache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }

  function renderPanel() {
    var panel = document.querySelector('[data-wishlist-panel]');
    if (!panel) return;
    var list = panel.querySelector('[data-wishlist-panel-list]');
    var empty = panel.querySelector('[data-wishlist-panel-empty]');
    if (!list) return;

    if (items.length === 0) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.handle);
      })
    ).then(function (products) {
      list.innerHTML = products
        .map(function (product, i) {
          if (!product) return '';
          var image = product.featured_image
            ? '<img src="' +
              product.featured_image.replace(/\.(jpg|jpeg|png|webp)/i, '_120x$&') +
              '" alt="" loading="lazy" width="56" height="56">'
            : '';
          return (
            '<li class="wishlist-panel__item">' +
            '<a href="' +
            product.url +
            '" class="wishlist-panel__item-link">' +
            '<span class="wishlist-panel__item-image">' +
            image +
            '</span>' +
            '<span class="wishlist-panel__item-title">' +
            product.title +
            '</span>' +
            '</a>' +
            '<button type="button" class="wishlist-panel__item-remove" data-wishlist-remove="' +
            items[i].id +
            '" aria-label="' +
            window.wishlistStrings.remove +
            '">&times;</button>' +
            '</li>'
          );
        })
        .join('');

      list.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggle(btn.getAttribute('data-wishlist-remove'));
        });
      });
    });
  }

  function renderPage() {
    var grid = document.querySelector('[data-wishlist-page-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-page-empty]');
    var removeLabel = (window.wishlistPageStrings && window.wishlistPageStrings.remove) || '×';

    if (items.length === 0) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(
      items.map(function (item) {
        return fetchProduct(item.handle);
      })
    ).then(function (products) {
      grid.innerHTML = products
        .map(function (product, i) {
          if (!product) return '';
          var image = product.featured_image
            ? '<img src="' +
              product.featured_image.replace(/\.(jpg|jpeg|png|webp)/i, '_600x$&') +
              '" alt="" loading="lazy" width="480" height="640">'
            : '';
          return (
            '<li class="wishlist-page__item">' +
            '<button type="button" class="wishlist-page__item-remove" data-wishlist-remove="' +
            items[i].id +
            '" aria-label="' +
            removeLabel +
            '">&times;</button>' +
            '<a href="' +
            product.url +
            '" class="wishlist-page__item-image">' +
            image +
            '</a>' +
            '<h2 class="wishlist-page__item-title"><a href="' +
            product.url +
            '">' +
            product.title +
            '</a></h2>' +
            '<div>' +
            (product.price_varies && window.wishlistPageStrings.fromPrefix
              ? window.wishlistPageStrings.fromPrefix + ' '
              : '') +
            (product.price / 100).toFixed(2) +
            ' €</div>' +
            '</li>'
          );
        })
        .join('');

      grid.querySelectorAll('[data-wishlist-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          toggle(btn.getAttribute('data-wishlist-remove'));
        });
      });
    });
  }

  function render() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButton);
    updateCounters();
    renderPanel();
    renderPage();
  }

  function bindButton(button) {
    if (button.dataset.wishlistBound) return;
    button.dataset.wishlistBound = 'true';
    button.addEventListener('click', function (event) {
      event.preventDefault();
      var id = button.getAttribute('data-product-id');
      var handle = button.getAttribute('data-product-handle');
      if (!id) return;
      toggle(id, handle);
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(bindButton);
    render();
  }

  window.wishlistStrings = window.wishlistStrings || {
    add: 'Add to wishlist',
    remove: 'Remove from wishlist',
  };

  window.duschenmannWishlist = {
    getItems: function () {
      return items.slice();
    },
    has: has,
    toggle: toggle,
    count: count,
  };

  function resync() {
    items = readItems();
    bindAll();
    if (customerId) syncFromRemote();
  }

  document.addEventListener('DOMContentLoaded', resync, { once: true });
  document.addEventListener('shopify:section:load', bindAll);
  document.addEventListener('wishlist:updated', render);

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) resync();
  });

  if (document.readyState !== 'loading') {
    resync();
  }
})();
